import {
  ORDERS_FETCH_FAILURE,
  ORDERS_FETCH_REQUEST,
  ORDERS_FETCH_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
  orders: [],      
  totalOrders: 0,   
  loading: false,   
  error: null,      
};

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORDERS_FETCH_REQUEST:
      return { 
        ...state, 
        loading: true, 
        error: null 
      };
      
    case ORDERS_FETCH_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        orders: action.payload.orders, 
        totalOrders: action.payload.totalOrders,
      };

    case ORDERS_FETCH_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: action.payload 
      };

    default:
      return state;
  }
};

export default ordersReducer;
